// src/pages/RoomIdeaGenerator.jsx

import React from "react";
import RoomIdeaTool from "./tools/room-ideas/RoomIdeaTool";

const RoomIdeaGenerator = () => {
  return (
    <div className="room-idea-generator-page">
      <RoomIdeaTool />
    </div>
  );
};

export default RoomIdeaGenerator;
